import styled from "styled-components";
import { checkedInColors } from "src/components/CheckedIn/CheckedInStyles";
import { EnumSurveyType } from "../components/Enums";
import { QuestionType } from "./surveyApi";

export const SurveyIntro = styled.section`
    position: relative;
    padding: 20px 76px 28px;
    text-align: center;
    background: var(--checked-in-background);
    color: var(--checked-in-primary);
    > button { position: absolute; top: 20px; right: 20px; }
    p { margin: 20px auto 0; max-width: 560px; font-size: 17px; line-height: 1.45; }
`;

export const CompanyLogo = styled.img`
    display: block;
    width: auto;
    height: auto;
    max-width: min(220px, 75%);
    max-height: 90px;
    object-fit: contain;
    margin: 12px auto 24px;
`;

export const SurveyMeta = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    background: #efefef;
    padding: 16px 20px;
    font-size: 14px;
    > span { display: inline-flex; align-items: center; gap: 8px; }
    strong { font-size: 18px; }
`;

export const SurveyTypeIcons = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 2px;
    img { display: block; width: 25px; height: 25px; object-fit: contain; }
`;

export const SurveyCardActions = styled.div`
    padding: 20px;
    display: flex;
    justify-content: center;
    button { width: 100%; }
`;

export const SurveyForm = styled.form`
    margin: 0;
    color: ${checkedInColors.black};
    h2 { font-size: 23px; line-height: 1.3; margin: 0; padding: 24px 20px; text-align: center;
        border-bottom: 1px solid #e5e5e5; overflow-wrap: anywhere; }
`;

export const QuestionField = styled.fieldset`
    border: 0;
    border-bottom: 1px solid #e5e5e5;
    padding: 28px 20px;
    margin: 0;
    min-width: 0;
    legend { float: left; width: 100%; padding: 0; text-align: center; font-size: 18px;
        font-weight: 600; line-height: 1.4; overflow-wrap: anywhere; margin-bottom: 20px; }
    > div { clear: both; }
    textarea { clear: both; }
`;

export const ChoiceGroup = styled.div<{ $count: number }>`
    display: grid;
    grid-template-columns: repeat(${p => p.$count}, minmax(0, 1fr));
    width: 100%;
    max-width: ${p => p.$count === 2 ? "190px" : "390px"};
    gap: clamp(4px, 2vw, 12px);
    margin: 0 auto;
`;

export const ChoiceLabel = styled.label<{ $selected: boolean; $dimmed: boolean; $type: QuestionType }>`
    display: grid;
    place-items: center;
    position: relative;
    min-width: 0;
    min-height: 52px;
    padding: 4px;
    border: 2px solid transparent;
    border-radius: 50%;
    overflow: hidden;
    input { position: absolute; inset: 0; width: 100%; height: 100%; opacity: 0; margin: 0; cursor: pointer; }
    input:disabled { cursor: default; }
    img { display: block; width: 100%; max-width: 68px; height: auto; aspect-ratio: 1; object-fit: contain;
        transform: ${p => p.$type === EnumSurveyType.YESNO ? "none" : "scale(1.6)"};
        opacity: ${p => p.$dimmed ? 0.6 : 1};
        filter: ${p => p.$selected && p.$type !== EnumSurveyType.YESNO ? "none" : "grayscale(1)"}; }
    &:has(input:focus-visible) { outline: 3px solid var(--checked-in-primary); outline-offset: 2px; }
`;

export const SurveySubmit = styled.footer`
    position: sticky;
    bottom: 0;
    background: ${checkedInColors.white};
    border-top: 1px solid #eee;
    padding: 16px 20px max(16px, env(safe-area-inset-bottom));
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    z-index: 5;
    button { width: min(100%, 320px); align-self: center; }
`;

export const SurveyError = styled.p`
    margin: 12px 0 0;
    color: #a12e20;
    line-height: 1.4;
    text-align: center;
`;

export const SurveyConfirmation = styled.section`
    position: relative;
    min-height: calc(100dvh - 64px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding: 90px 24px;
    text-align: center;
    background: var(--checked-in-background);
    color: var(--checked-in-primary);
    > button { position: absolute; top: 20px; right: 20px; }
    h1 { font-size: 24px; line-height: 1.3; margin: 0; }
    p { max-width: 520px; margin: 0; font-size: 17px; line-height: 1.5; }
`;
